const xssCheck = (str) => {
  /* eslint-disable */
  if (str) {
    str = str.replace(/\</g, '&lt;');
    str = str.replace(/\>/g, '&gt;');
  }
  /* eslint-enable */
  return str;
};

export default {
  xssCheck
};
